<template>
  <div
    class="border-2 border-gray-600 border-opacity-25 border-dashed rounded-2xl mx-5 md:mx-10 xl:mx-32 p-5 xl:p-10 w-full"
  >
    <p class="text-base text-center uppercase mb-5">
      Clôturer l'évaluation en date du
      <span class="text-pink-600">{{ today }}</span>
    </p>
    <div
      class="flex flex-wrap flex-col md:flex-row justify-center items-center space-x-0 gap-y-3 md:space-x-3 md:space-y-0 md:max-w-full"
    >
      <action-button
        border-color="border-transparent"
        text-color="text-white"
        bg-color="bg-indigo-600"
        bg-color-square="bg-indigo-600"
        icon-color="text-white"
        libelle="Clôturer l'évaluation"
        :uppercase="true"
        icon="save"
        @clickAction="$emit('confirmCloseEvaluation')"
      />
      <!-- TODO : handle compcle cartography -->
      <action-button
        v-if="!$isMobile() && canCompareCartography"
        border-color="border-indigo-600"
        text-color="text-indigo-600"
        bg-color="bg-white"
        bg-color-square="bg-white"
        icon-color="text-pink-600"
        libelle="Comparer les cartographies"
        :uppercase="true"
        icon="bar-chart-2"
        @clickAction="$emit('displayCompareCarto')"
      />
      <action-button
        v-if="!$isMobile() && canCompareButNotEnoughEvaluation"
        border-color="border-indigo-600"
        text-color="text-indigo-600"
        bg-color="bg-white"
        bg-color-square="bg-white"
        icon-color="text-pink-600"
        libelle="Comparer les cartographies"
        icon="bar-chart-2"
        :uppercase="true"
        :is-disabled="true"
        disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
      />
    </div>
    <p
      v-if="currentEval"
      class="text-base text-center mt-5 text-gray-700"
    >
      Dernière modification apportées le
      {{ new Date(currentEval.updated_at).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' }) }}
      à
      {{ new Date(currentEval.updated_at).toLocaleTimeString() }}
    </p>
  </div>
</template>

<script>
import ActionButton from './../ActionButton.vue';
import {mapGetters} from 'vuex';

export default {
  components: {
    ActionButton,
  },

  props: {
    today: String,
    libelleTemplate: String,
    canCompareCartography: Boolean,
    canCompareButNotEnoughEvaluation: Boolean,
  },

  computed: {
    ...mapGetters({
      currentEval: 'neopass/currentEval'
    }),
  }
};
</script>
